import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledRemainingDays = styled.div`
  display: flex;
  align-items: center;

  & > .value {
    font-size: 3rem;
    font-weight: 500;
    letter-spacing: -2.5px;
    margin-right: 1rem;
  }
  & > .description {
    color: ${getColor('shuttleGray')};
    font-size: 1.1rem;
  }

  &.isOverdue {
    & .value {
      color: ${getColor('radicalRed')};
    }
  }
`;
